/**
 * Request a Quote link
 * Restyles the BSS B2B Quote "Add to quote" button on the product page as a
 * text link. The app's own button is moved into [data-quote-link-slot] and
 * laid invisibly over the link text (see main-product.liquid CSS), so the
 * shopper clicks the real app button and it behaves exactly as before.
 *
 * Each [data-quote-link] only uses the app button inside its own <form>,
 * so multiple product forms on one page work independently.
 */
(function () {
  'use strict';

  /* If BSS changes its markup in an update, these are the lines to change. */
  var APP_WRAPPER_SELECTOR = 'bcp-r4q-button-wrapper[page="product"]';
  var APP_BUTTON_SELECTOR = 'bcp-r4q-button-main';

  /* Stop watching if the app never renders a button (app disabled, or the
     product isn't quote-eligible). Once found, keep watching for re-renders. */
  var OBSERVER_TIMEOUT_MS = 10000;

  function init(link) {
    if (link.dataset.quoteLinkReady) return;
    var scope = link.closest('form');
    var slot = link.querySelector('[data-quote-link-slot]');
    if (!scope || !slot) return;
    link.dataset.quoteLinkReady = 'true';

    /* Lets the CSS hide the app's button in its original spot — only after
       this script has run, so it stays usable if this file fails to load. */
    scope.classList.add('quote-link-enhanced');

    var found = false;
    var frame = null;

    function sync() {
      frame = null;

      /* Move any wrapper the app rendered (or re-rendered after a variant
         change) into the link. The newest one ends up last and is the one
         shown; older ones are hidden by CSS. */
      scope.querySelectorAll(APP_WRAPPER_SELECTOR).forEach(function (wrapper) {
        if (!slot.contains(wrapper)) slot.appendChild(wrapper);
      });

      var wrappers = slot.querySelectorAll(APP_WRAPPER_SELECTOR);
      var current = wrappers[wrappers.length - 1];
      var hasAppButton = !!(current && current.querySelector(APP_BUTTON_SELECTOR));
      if (hasAppButton) found = true;
      link.hidden = !hasAppButton;
    }

    function scheduleSync() {
      if (frame === null) frame = requestAnimationFrame(sync);
    }

    var observer = new MutationObserver(scheduleSync);
    observer.observe(scope, { childList: true, subtree: true });
    setTimeout(function () {
      if (!found) observer.disconnect();
    }, OBSERVER_TIMEOUT_MS);

    sync();
  }

  function initAll(root) {
    root.querySelectorAll('[data-quote-link]').forEach(init);
  }

  initAll(document);

  /* Theme editor: re-init when the section is re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
